import { useState } from 'react';

function useCarousel(availableSlides = [], startSlide = '') {
  const [activeSlide, setActiveSlide] = useState(startSlide);
  const [slideIndex, setslideIndex] = useState(0);

  const nextSlide = () => {
    const newIndex = slideIndex + 1;

    if (newIndex <= availableSlides.length) {
      setslideIndex(newIndex);
      setActiveSlide(availableSlides[newIndex]);
    }
  };

  const previousSlide = () => {
    const newIndex = slideIndex - 1;

    if (newIndex < availableSlides.length) {
      setslideIndex(newIndex);
      setActiveSlide(availableSlides[newIndex]);
    }
  };

  const resetSlide = () => {
    setslideIndex(0);
    setActiveSlide(startSlide);
  };

  return {
    activeSlide,
    slideIndex,
    setslideIndex,
    nextSlide,
    previousSlide,
    resetSlide,
  };
}

export default useCarousel;
